var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"auto","height":"100%"}},[_c('img',{staticStyle:{"position":"absolute","z-index":"-100","width":"100%","height":"175px"},attrs:{"src":require("../assets/img/top.jpg")}}),_c('v-menu'),_c('div',{staticClass:"main-width content-height"},[_c('router-view')],1),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }